const BASE = process.env.ENV === 'preview' ? 'api/gp-task-worker-staging/' : 'api/gp-task-worker/'
const urls = {
  // code换取openId
  rechargeGetUserWxInfo: 'get api/v1/order/recharge/service/getUserWxInfoFromOa'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS



// WEBPACK FOOTER //
// ./src/apis/api-urls/gp-task-worker.js